// import videojs from 'video.js';
let video = require('video.js');
